import type { GridsterConfig } from 'angular-gridster2';

export const ReportDashboardGridsterBaseConfig = {
  gridType: 'verticalFixed',
  // displayGrid: 'always',
  displayGrid: 'onDrag&Resize',
  pushItems: true,
  pushResizeItems: false,
  pushDirections: { north: false, east: false, south: true, west: false },
  swap: true,
  disableScrollHorizontal: true,
  compactType: 'compactUp',
  scrollToNewItems: false,
  fixedRowHeight: 172,
  outerMarginTop: 10,
  outerMarginRight: 20,
  outerMarginLeft: 20,
  margin: 12,
  minCols: 12,
  maxCols: 12,
  maxItemCols: 12,
} satisfies GridsterConfig;
